<div *ngIf="efastErrorState" id="{{efastFieldId}}" [@slideInOut] aria-live="polite" role="alert">
	<svg class="usa-icon" aria-hidden="true" style="color: #d83933;"focusable="false" role="img">
		<use xlink:href="/assets/img/sprite.svg#error"></use>
	</svg>
	<span style="color: #d83933;font-weight: bold;" tabindex="0" id="inputValidationErrorMessage" >{{efastErrorMsg}}</span>
</div>
